import { render, staticRenderFns } from "./aldehyde.vue?vue&type=template&id=6d777486&"
import script from "./aldehyde.vue?vue&type=script&lang=js&"
export * from "./aldehyde.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports